import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Typography,
  Card,
  CardContent,
  Box,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  InputAdornment,
  IconButton,
  Backdrop,
  Input,
  CircularProgress,
  AppBar,
  Container
} from '@material-ui/core';

import { useClientContext } from '../context/client_context';
import { useAccountingContext } from '../context/accounting_context';
import { baseUrl } from '../utils/constants';
import Controls from '../components/controls/Controls';

import PersonalDetails from '../components/clients/PersonalDetails';
import SubsTransactions from '../components/clients/SubsTransactions';
import ProvidentSubs from '../components/clients/ProvidentTrans';
import ClientNotes from '../components/clients/ClientNotes';
import Dependants from '../components/clients/Dependants';
import SubsTransZim from '../components/clients/SubsTransZim';
import ProvidentZwd from '../components/clients/ProvidentZwd';

export default function MemberSummary() {
  const [index, setIndex] = useState(0);
  const { getLimitUsage, getLimitTotalUsage, setClaimDetailsList } = useClientContext();
  const { refId, setRefId } = useAccountingContext();
  const [docSearchCode, setSearchCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });

  useEffect(() => {
    // getMemberInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onTabClicked = (event, index) => {
    setIndex(index);
  };

  const Panel = (props) => <div hidden={props.value !== props.index}>{props.children}</div>;

  const getProviderInfo = async (event) => {
    if (docSearchCode === '') {
      notifyPopup(`No AHFOZ # Selected, please enter number to seach for!`, 'error');
      return;
    }
    setLoading(true);
    await axios(`${baseUrl}/api/setting/GetProvider?namasNo=${docSearchCode}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Doctor/Medical Practise not Found!: ${result.replyMessage}`, 'error');
        } else {
          console.log('returned doctor', result);
          //   setDoctor(result.data);
          //   setProviderId(result.data.provider_id);
          setRefId(result.data.provider_id);
        }
      },
      (error) => {
        notifyPopup(`Error in Searching for Medical Practise!: ${error}`, 'error');
      }
    );
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card>
        <CardContent>
          <AppBar position="static" color="grey">
            <Tabs
              value={index}
              indicatorColor="primary"
              // textColor="white"
              onChange={onTabClicked}
              aria-label="simple tabs example"
            >
              <Tab label="Member Details" />
              <Tab label="Subs US$$" />
              <Tab label="Subs ZWD" />
              <Tab label="Provident US$" />
              <Tab label="Provident ZWD" />
              <Tab label="Dependants" />
              <Tab label="Notes" />
            </Tabs>
          </AppBar>
          <Box>.</Box>
          <Panel value={index} index={0}>
            <PersonalDetails />
          </Panel>
          <Panel value={index} index={1}>
            <SubsTransactions />
          </Panel>
          <Panel value={index} index={2}>
            <SubsTransZim />
          </Panel>
          <Panel value={index} index={3}>
            <ProvidentSubs />
          </Panel>
          <Panel value={index} index={4}>
            <ProvidentZwd />
          </Panel>
          <Panel value={index} index={5}>
            <Dependants />
          </Panel>
          <Panel value={index} index={6}>
            <ClientNotes />
          </Panel>
        </CardContent>
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </Card>
    </Container>
  );
}
